export enum STORE_MUTATION {
    SetActiveDb = "setActiveDb",
    SetPageLoaded = "setPageLoaded",
    SetActiveTab = "SetActiveTab"
}